import * as types from '../constants/ActionTypes';

export function changeShopCollection(data) {
  console.log('action dispatched: change shop collection')
  return {
    type: types.CHANGE_SHOP_COLLECTION,
    payload: data
  };
}

export function changeShopGender(data) {
  console.log('action dispatched: change shop gender')
  return {
    type: types.CHANGE_SHOP_GENDER,
    payload: data
  };
}

export function setShopLoading(setShopLoading) {
  return {
    type: types.SET_SHOP_LOADING,
    setShopLoading
  };
}

export function setShopLoaded(setShopLoaded) {
  return {
    type: types.SET_SHOP_LOADED,
    setShopLoaded
  };
}


// WEBPACK FOOTER //
// ./src/store/actions/Shop.js